import { ref, computed } from "vue";
import { defineStore } from "pinia";

export const usePharmacyStore = defineStore("pharmacy store", () => {
  const pharmacy = ref(null);

  const getPharmacy = computed(() => pharmacy.value);

  function setPharmacy(data) {
    pharmacy.value = data;
  }

  return { getPharmacy, setPharmacy };
});
